import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IPackagingGroup } from "../packaginggroupModel";

export const getAllPackagingGroup = createAsyncThunk(
  "PackagingGroup/FindAllPackagingGroup",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackagingGroup/FindAllPackagingGroup`,
        {
          packaging_group: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActivePackagingGroup = createAsyncThunk(
  "PackagingGroup/FindAllActivePackagingGroup",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/PackagingGroup/FindAllActivePackagingGroup`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching PackagingGroup:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createPackagingGroup = createAsyncThunk(
  "PackagingGroup/InsertPackagingGroup",
  async (PackagingGroupData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackagingGroup/InsertPackagingGroup`,
        PackagingGroupData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating PackagingGroup:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updatePackagingGroup = createAsyncThunk(
  "PackagingGroup/UpdatePackagingGroup",
  async (PackagingGroupData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackagingGroup/UpdatePackagingGroup`,
        PackagingGroupData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating PackagingGroup:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getPackagingGroupByID = createAsyncThunk(
  "PackagingGroup/FindByIDPackagingGroup",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackagingGroup/FindByIDPackagingGroup`,
        { packaging_group_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        packaging_group: result.packaging_group,
        packaging_group_guid: result.packaging_group_guid,
        isactive: result.isactive === true ? 1 : 2,
      } as IPackagingGroup;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching PackagingGroup:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const PackagingGroupActiveInactive = createAsyncThunk(
  "PackagingGroup/ActiveInActivePackagingGroup",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackagingGroup/ActiveInActivePackagingGroup`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive PackagingGroup:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deletePackagingGroup = createAsyncThunk(
  "PackagingGroup/DeletePackagingGroup",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackagingGroup/DeletePackagingGroup`,
        { packaging_group_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting PackageTypes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
